import { create } from 'zustand';

/**
 * revealStore — capa PURAMENTE VISUAL para la animación de aparición del
 * workflow.
 *
 * Regla de oro: el workflow real ya está creado, configurado y válido en
 * `workflowStore` antes de que este store se active. Acá sólo se guarda qué
 * nodos/edges todavía NO se dibujaron, y el Canvas los marca `hidden` al
 * renderizar (igual que hace con el modo batch). Nada de esto se persiste ni
 * afecta el guardado, la configuración o la ejecución: si la animación falla
 * o se saltea, se vacía el store y todo queda visible y utilizable.
 */
export const useRevealStore = create((set) => ({
  active: false,
  hiddenNodes: [],
  hiddenEdges: [],
  order: [],          // orden en el que hay que revelar los nodos
  frame: 'all',       // 'all' (todo el proyecto) | 'targets' (el flujo nuevo)
  spotlightRun: false, // resalta "Ejecutar flujo completo" al terminar

  /** Arranca el revelado. Sin nodos nuevos no hace nada. */
  start: ({ nodeIds = [], edgeIds = [], frame = 'all' } = {}) => {
    if (!nodeIds.length) return;
    set({
      active: true,
      hiddenNodes: [...nodeIds],
      hiddenEdges: [...edgeIds],
      order: [...nodeIds],
      frame,
      spotlightRun: false,
    });
  },

  revealNode: (id) => set((s) => ({ hiddenNodes: s.hiddenNodes.filter((n) => n !== id) })),
  revealEdge: (id) => set((s) => ({ hiddenEdges: s.hiddenEdges.filter((e) => e !== id) })),

  /** Muestra todo de una (fin de animación, "saltar" o error). */
  finish: ({ spotlight = true } = {}) => set({
    active: false, hiddenNodes: [], hiddenEdges: [], order: [], frame: 'all',
    spotlightRun: spotlight,
  }),

  clearSpotlight: () => set({ spotlightRun: false }),
}));

export default useRevealStore;
